import { render, staticRenderFns } from "./EmptyView.vue?vue&type=template&id=4d8efea8&scoped=true"
import script from "./EmptyView.vue?vue&type=script&lang=js"
export * from "./EmptyView.vue?vue&type=script&lang=js"
import style0 from "./EmptyView.vue?vue&type=style&index=0&id=4d8efea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8efea8",
  null
  
)

export default component.exports